// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  CanonicalAddress,
} from "./types";

export default {
  googlePlaceId: __t.string(),
  name: __t.string(),
  businessType: __t.string(),
  get canonicalAddress() {
    return CanonicalAddress;
  },
  intendedInvestmentDollars: __t.u32(),
  reason: __t.option(__t.string()),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
};
